import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { UliDetailsInitialState, UliDetailsLoad } from './uli-details.actions';
import { UliDetailsPreviewCriteria, UliDetailsPreviewModel } from '../models/uli-details.model';
import { filter, map } from 'rxjs/operators';
import { UliDetailsState } from './uli-details.state';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../../common';
import { UliBriefFacade } from '../uli-brief/uli-brief.facade';
import { UliBriefModel } from '../models/uli-brief.model';

@Injectable({ providedIn: 'root' })
export class UliDetailsFacade implements SetInitialStateFacade, LoadDataFacade {
  data$: Observable<UliDetailsPreviewModel> = this.store.select(UliDetailsState.getData);
  loaded$: Observable<boolean> = this.store.select(UliDetailsState.getLoaded);

  constructor(private store: Store, private uliBriefFacade: UliBriefFacade) {}

  setInitialState(): void {
    this.store.dispatch(new UliDetailsInitialState());
  }

  loadAll(): void {
    this.getUliDetailsCriteria().subscribe((criteria: UliDetailsPreviewCriteria) => this.loadUliDetails(criteria));
  }

  loadUliDetails(criteria: UliDetailsPreviewCriteria): void {
    this.store.dispatch(new UliDetailsLoad(criteria));
  }

  private getUliDetailsCriteria(): Observable<UliDetailsPreviewCriteria> {
    return this.uliBriefFacade.uli$.pipe(
      filter(Boolean),
      map((uliData: UliBriefModel) => ({
        compartmentId: uliData.compartmentId,
        uli: uliData.uli,
        type: uliData.type,
      })),
    );
  }
}
